import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
  type QueryKey,
} from '@tanstack/react-query';
import service from '../service';
import type { PromoCode } from '../types/promoCode';
import { promoCodeQueryKeys } from './usePromoCodes';

type DefaultError = unknown;

type UsePromoCodeParams = {
  id: string;
  include?: string;
  enabled?: boolean;
};

export function usePromoCode<TData = PromoCode, TError = DefaultError>(
  { id, include, enabled = true }: UsePromoCodeParams,
  options?: Omit<
    UseQueryOptions<PromoCode, TError, TData, QueryKey>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  const queryKey: QueryKey = promoCodeQueryKeys.detail(id);
  const fullQueryKey = include ? [...queryKey, include] : queryKey;

  return useQuery<PromoCode, TError, TData>({
    queryKey: fullQueryKey,
    enabled: enabled && !!id,
    queryFn: async () => service.getPromoCode(id, { include }),
    ...(options as any),
  });
}
